<template>
  <div v-if="!loading" class="rounded bg-white overflow-hidden shadow">
    <div class="flex divide-x">
      <div v-if="taskOrderItem" class="w-64">
        <OrderLinesNav
          :task-order-item="taskOrderItem"
          :current="current"
          @order-line:changed="current = $event"
        />
      </div>
      <div class="flex-1">
        <OrderItemDetails
          v-if="currentOrderItem"
          :order-item="currentOrderItem"
          :can-copy="true"
          :copying="copying"
          @requirements:copy="copyRequirements"
          @links:copy="copyLinks"
          @notes:copy="copyNotes"
          @media:copy="copyMedia"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderItemDetails from './taskOrderItem/OrderItemDetails.vue';
import OrderLinesNav from './taskOrderItem/OrderLinesNav.vue';

export default {
  name: 'TaskOrderItem',

  components: {
    OrderItemDetails,
    OrderLinesNav,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
    orderItemId: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
    notes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: false,
      current: null,
      copying: false,
    };
  },

  computed: {
    taskOrderItem() {
      return this.$store.state.entities.orderItems.byId[this.orderItemId] || null;
    },
    currentOrderItem() {
      return this.$store.state.entities.orderItems.byId[this.current] || null;
    },
  },

  created() {
    this.current = this.orderItemId;
    this.init();
  },

  methods: {
    setCopying(copying = true) {
      this.copying = copying;
    },
    async init() {
      this.loading = true;
      try {
        await this.$store.dispatch({
          type: 'ui/orderItems/read',
          orderItemUuid: this.orderItemId,
          params: {
            include: 'order.orderItems.notes,order.orderItems.media,order.orderItems.links',
          },
        });
      } catch (error) {
        /** something went wrong */
      } finally {
        this.loading = false;
      }
    },
    copyRequirements(content) {
      this.$emit('update:content', content);
    },
    async copyLinks(links) {
      this.setCopying();
      await Promise.all(
        links.map(async (link) => {
          await this.$store.dispatch({
            type: 'ui/taskLinks/store',
            taskId: this.task.uuid,
            formData: { ...link },
          });
        })
      );
      this.setCopying(false);
    },
    async copyNotes(notes) {
      this.setCopying();
      await Promise.all(
        notes.map(async (note) => {
          await this.$store.dispatch({
            type: 'ui/taskNotes/store',
            taskId: this.task.uuid,
            formData: { ...note },
          });
        })
      );
      this.setCopying(false);
    },
    copyMedia(mediaAsLinks) {
      this.copyLinks(mediaAsLinks);
    },
  },
};
</script>
